const SharedTokenService = {
  url: `${process.env.VUE_APP_API_URL}shared-tokens/`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },

  create: async () => {
    try {
      const headers = SharedTokenService.headers;
      headers["Authorization"] = "Bearer " + localStorage.getItem("token");

      const response = await fetch(`${SharedTokenService.url}create`, {
        method: "POST",
        headers: headers,
      });

      return response;
    } catch (e) {
      return false;
    }
  },

  delete: async () => {
    try {
      const headers = SharedTokenService.headers;
      headers["Authorization"] = "Bearer " + localStorage.getItem("token");

      const response = await fetch(`${SharedTokenService.url}delete`, {
        method: "POST",
        headers: headers,
      });

      return response;
    } catch (e) {
      return false;
    }
  },
};

export default SharedTokenService;
